// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ur5y","label":"styles_label__1A5VZ"};